import { css } from 'react-strict-dom';
import { useTimer } from 'src/contexts';

import ErrorList from './ErrorList';

type Props = {
  style?: css.StyleXStyles;
};

/**
 * Says when a start or a stop did not take.  Sits wherever a timer has the
 * room for it, since the controls themselves are too small to say anything.
 */
export default function TimerError({ style }: Props) {
  const { actionError } = useTimer();
  if (!actionError) return null;

  return <ErrorList errors={[actionError]} style={style} />;
}
